import { jsx as c, jsxs as y } from "react/jsx-runtime";
import { c as A } from "../../index-2QXL0WYc.js";
import { F as E, s as p } from "../../FieldAppendToLabel-DgXoSKDG.js";
import { useMemo as o, isValidElement as q } from "react";
import { IressLabel as V } from "../Label/Label.js";
import { propagateTestid as k } from "../../helpers/utility/propagateTestid.js";
import { toArray as w } from "../../helpers/formatting/toArray.js";
const K = ({
  children: d,
  className: a,
  "data-testid": m,
  error: l,
  errorMessages: t,
  hiddenLabel: i,
  hint: f,
  htmlFor: u,
  label: F,
  optional: v,
  required: x,
  readOnly: N,
  ...b
}) => {
  const h = o(
    () => !!l || (t == null ? void 0 : t.length),
    [l, t == null ? void 0 : t.length]
  ), j = o(
    () => !f && !l && !(t != null && t.length) ? null : /* @__PURE__ */ c(
      E,
      {
        hint: f,
        error: l,
        errorMessages: t,
        hiddenLabel: i,
        "data-parent-testid": m
      }
    ),
    [m, l, t, i, f]
  );
  let n = u;
  return n === void 0 && q(d) && (n = w(d)[0].props.id), /* @__PURE__ */ y(
    "div",
    {
      className: A(a, {
        [p.field]: !0,
        [p.invalid]: h,
        [p.hiddenLabel]: i === !0
      }),
      "data-testid": m,
      ...b,
      children: [
        /* @__PURE__ */ c(
          V,
          {
            append: j,
            className: p.label,
            "data-testid": k(m, "label"),
            hiddenLabel: i,
            htmlFor: n,
            optional: v,
            required: N ? !1 : !!x,
            children: F
          }
        ),
        d
      ]
    }
  );
};
export {
  K as IressField
};
